import { Controller } from "@hotwired/stimulus"
import { createWidget } from '@typeform/embed'


export default class extends Controller {
  static values = {
    id: String,
  }
  static targets = ["container", "button"]

  connect() {
    createWidget(this.idValue, {
      container: this.containerTarget,
      hideHeaders: true,
      hideFooter: true,
      enableSandbox: true,
      keepSession: false,
      onSubmit: () => {
        this.handleSubmitButtonClick();
      },
      onEndingButtonClick: () => {
        this.handleEndingButtonClick();
      }
    })
  }

  handleEndingButtonClick() {
    this.buttonTarget.click();
  }

  handleSubmitButtonClick() {
  }
}
